import type { CSSProperties, PropsWithChildren } from 'react';
import React from 'react';

import { GX_HIGHLIGHT } from '@/config/colors';
import { Z_INDEX } from '@/config/z-index';

import './ElectricBorder.css';

type ElectricBorderProps = PropsWithChildren<{
  color?: string;
  pulsate?: boolean;
  durationMs?: number;
  animate?: boolean;
}>;

type ElectricBorderStyle = CSSProperties & {
  '--electric-border-color': string;
  '--electric-border-duration': string;
  '--electric-border-z-index': number;
};

const ElectricBorder: React.FC<ElectricBorderProps> = ({
  children,
  color = GX_HIGHLIGHT,
  pulsate = true,
  durationMs = 1500,
  animate = true
}: ElectricBorderProps) => {
  const style: ElectricBorderStyle = {
    '--electric-border-color': color,
    '--electric-border-duration': `${durationMs}ms`,
    '--electric-border-z-index': Z_INDEX.sticky
  };

  return (
    <div
      className='electric-border'
      style={style}
    >
      {animate && (
        <div
          aria-hidden='true'
          className='electric-border__layers'
          data-pulsate={pulsate}
        >
          <div className='electric-border__line' />
          <div className='electric-border__line electric-border__glow electric-border__glow--near' />
          <div className='electric-border__line electric-border__glow electric-border__glow--far' />
        </div>
      )}
      <div className='electric-border__content'>{children}</div>
    </div>
  );
};

export default ElectricBorder;
